import template from './view.html'

export default function breadcrumb($state) {
  return {
    restrict: 'E',
    template,
    scope: {
      depth: '<',
      paths: '<',
    },
    link(scope) {
      if (scope.paths) {
        return
      }
      const paths = []
      let stateName
      const currentStateArr = $state.current.name.split('.')
      let depth = scope.depth || 2
      const { length } = currentStateArr
      for (; depth < length; depth++) {
        stateName = currentStateArr.slice(0, depth + 1).join('.')
        const state = $state.get(stateName)
        if (state.title) {
          paths.push({
            title: state.title,
            href: state.abstract ? state.default : state.name,
          })
        }
      }
      scope.paths = paths
    },
  }
}
breadcrumb.$inject = ['$state']



// WEBPACK FOOTER //
// ./src/components/breadcrumb/breadcrumbDirective.js